import clsx from 'clsx';
import React from 'react';
import { vars } from 'src/core/themes';
import { TableSortingIconV2 } from 'src/svgs/TableSortingIconV2';

import * as styles from './SortButton.css';
import {
  getNextSortStatus,
  SortButtonProps,
  SortStatus,
} from './SortButton.utils';

export function SortButtonV3({
  onClick,
  sortStatus,
  disabled = false,
  allowUnsorted = true,
  sortIndex,
}: SortButtonProps) {
  return (
    <div
      onClick={(e: React.MouseEvent) => {
        !disabled && onClick?.(getNextSortStatus(sortStatus, allowUnsorted), e);
      }}
      className={styles.sortIconContainerV3}
      data-testid="sort-button"
    >
      <TableSortingIconV2
        size={vars.iconSize.l}
        isActive={sortStatus !== SortStatus.UNSORTED}
        className={clsx({
          [styles.upsideDown]: sortStatus === SortStatus.DESC,
        })}
      />
      {sortIndex && <span className={styles.sortIndexBadge}>{sortIndex}</span>}
    </div>
  );
}
